export const ACCESS_TOKEN_NAME = 'accessToken';
export const ACCESS_TOKEN_USER = 'accessTokenUser';
